module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_06@3x-cc2564926cc9d55f36a388c1d8d4e700.webp";